import { defineMessages } from "react-intl";

const messages = defineMessages({
    loading: {
        id: "general.loading",
    },
    editScore: {
        id: "tasks.melodyTable.editScore",
    },
    stopEdit: {
        id: "tasks.stopEdit",
    },
    firstKnown: {
        id: "tasks.melodyTable.firstKnown",
    },
    showPitches: {
        id: "tasks.solfaName.showPitches",
    },
    withSolfa: {
        id: "tasks.piano.withSolfa",
    },
    createScoreTooltip: {
        id: "score.saveTooltip",
    },
});

export default messages;
